 
import { Toaster } from 'react-hot-toast';
import Header from './components/Header';
import MonitorDashboard from './components/MonitorDashboard';

/**
 * 主应用组件
 */
function App() {
  // 空的更新函数，用于传递给子组件
  const handleStatsUpdate = () => {
    // 可以在这里添加全局状态更新逻辑
          // 统计数据已更新
  };

  return (
    <div className="min-h-screen bg-base-100">
      <Header />
      <MonitorDashboard 
        onStatsUpdate={handleStatsUpdate}
      />
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#363636',
            color: '#fff',
          },
        }}
      />
    </div>
  );
}

export default App; 